<template>
    <div class="row">
        <div class="col-12 px-0">
            <ul class="qf-dashboard-navigation">
                <li class="qf-active-nav">
                    <a href="#!" @click.prevent>
                        {{$ml.get('reports')}}
                    </a>
                </li>
                <li v-if="loading">
                    <a @clisk.prevent>
                        <font-awesome-icon icon="spinner" class="fa-spin"/>
                    </a>
                </li>
                <li></li>
            </ul>
        </div>
        <div class="col-12">
            <a href="/dashboard" @click.prevent="$router.back()" class="small">&lt;&nbsp;{{$ml.get('Back')}}</a>
        </div>
        <div class="col-12 h2 pt-5 text-center" v-if="loading">
            <font-awesome-icon icon="spinner" size="2x" class="fa-spin"/>
        </div>
        <div class="col-12 pt-3" v-if="!loading">
            <div class="row text-center mb-2">
                <div class="col-4 pr-1">
                    {{$ml.get('Monitored_trademark')}}
                </div>
                <div class="col-2 px-1">
                    {{$ml.get('VCL')}}
                </div>
                <div class="col-2 px-1">
                    {{$ml.get('NCL')}}
                </div>
                <div class="col-4 pl-1">
                    {{$ml.get('Time_to_respond')}}
                </div>
            </div>
            <div class="row align-items-stretch mb-3">
                <div class="col-4 pr-0">
                    <div class="qf-bg-white p-2 qf-report-border h-100 flex-column flex-sm-row d-flex align-items-center">
                        <div class="w-25">
                            <div class="qf-w-50px qf-brand-logo text-center mx-auto">
                                <img :src="`${$store.state.baseUrl}${report.user_trademark.logo_path}`"
                                     alt="logo" class="img-fluid"
                                     v-if="report.user_trademark.logo_path !== undefined && report.user_trademark.logo_path.length">
                                <img src="../../../assets/img/placeholders/logo.png" alt="logo"
                                     class="img-fluid" v-else>
                            </div>
                        </div>
                        <div class="w-75">
                            {{report.user_trademark.title}}
                        </div>
                    </div>
                </div>
                <div class="col-4 px-1">
                    <div class="qf-bg-white p-2 qf-report-border h-100 d-flex align-items-center devider-mid position-relative">
                        <div class="w-50 px-2 small">
                            {{report.user_trademark.vienna_classes | joinViennaClasses}}
                        </div>
                        <div class="w-50 px-2 small">
                            {{report.user_trademark.nice_classes | joinNiceClasses}}
                        </div>
                    </div>
                </div>
                <div class="col-4 pl-0">
                    <div class="qf-bg-white p-2 qf-report-border h-100 d-flex align-items-center">
                        <div>
                            {{report.days_to_respond}} {{$ml.get('days')}}
                        </div>
                    </div>
                </div>
            </div>

            <div class="row text-center mb-2">
                <div class="col-4 pr-0">
                    {{$ml.get('Result_Trademark')}}
                </div>
                <div class="col-4 px-1">
                    {{$ml.get('Legal_Information')}}
                </div>
                <div class="col-4 pl-0">
                    {{$ml.get('Registration_Information')}}
                </div>
            </div>
            <div class="row align-items-stretch mb-3">
                <div class="col-4 pr-0">
                    <div class="qf-bg-white p-2 qf-report-border h-100 d-flex align-items-center">
                        <div>
                            <img :src="`${$store.state.baseUrl}${report.matched_trademark.logo}`"
                                 alt="logo" class="img-fluid"
                                 v-if="report.matched_trademark.logo && report.matched_trademark.logo.length">
                            <img src="../../../assets/img/placeholders/logo.png" alt="logo"
                                 class="img-fluid" v-else>
                        </div>
                    </div>
                </div>
                <div class="col-4 px-1">
                    <div class="qf-bg-white p-2 qf-report-border h-100 d-flex align-items-center small"
                         :class="{'qf-border-orange': report.title_match}">
                        <div>
                            <strong>Title: </strong>{{report.matched_trademark.title}}<br>
                            <strong>Owner: </strong>{{report.matched_trademark.owner.identifier}}<br>
                            <strong>Representative: </strong><span
                                v-if="report.matched_trademark.representative !== undefined">{{report.matched_trademark.representative.name}}</span>
                        </div>
                    </div>
                </div>
                <div class="col-4 pl-0">
                    <div class="qf-bg-white p-2 qf-report-border h-100 d-flex align-items-center small">
                        <div>
                            <strong>Request Number: </strong>{{report.matched_trademark.application_number}}<br>
                            <strong>Application Date: </strong>{{report.matched_trademark.application_date |
                            dateFormat}}<br>
                            <strong>Registration Number: </strong>{{report.matched_trademark.register_number}}<br>
                            <strong>Date Of Registration: </strong>{{report.matched_trademark.registration_date |
                            dateFormat}}<br>
                            <strong>Status: </strong>{{report.matched_trademark.status}}<br>
                            <strong>Contestation Date: </strong>{{report.matched_trademark.contestation | dateFormat}}
                        </div>
                    </div>
                </div>
            </div>
            <div class="row text-center mb-2">
                <div class="col-12">
                    {{$ml.get('Vienna_Classes')}}
                </div>
            </div>
            <div class="row align-items-stretch mb-3">
                <div class="col-12">
                    <div class="qf-bg-white p-2 qf-report-border h-100 d-flex small"
                         :class="{'qf-border-orange': report.vienna_match}">
                        <div>
                            {{report.matched_trademark.vienna_classes | joinViennaClasses }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="row text-center mb-2">
                <div class="col-12">
                    {{$ml.get('Nice_Classes')}}
                </div>
            </div>
            <div class="row align-items-stretch mb-3">
                <div class="col-12">
                    <div class="qf-bg-white p-2 qf-report-border h-100 d-flex align-items-center"
                         :class="{'qf-border-orange': report.nice_match}">
                        <div>
                            <table>
                                <tr v-for="(niceClass, index) in report.matched_trademark.nice_classes" :key="index">
                                    <td class="pb-2 pr-1 qf-vertical-align-top"><strong>{{niceClass.class}}</strong>
                                    </td>
                                    <td class="pb-2 qf-smaller">{{niceClass.description}}</td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "SingleReport",
        props: {
            id: {type: [String, Number]}
        },
        filters: {
            joinViennaClasses(value) {
                if (value === undefined || value.length === 0) {
                    return '';
                }
                let outputArray = [];
                value.forEach(obj => {
                    outputArray.push(obj.class_id);
                });
                return outputArray.join(', ')
            },
            joinNiceClasses(value) {
                if (value === undefined || value.length === 0) {
                    return '';
                }
                let outputArray = [];
                value.forEach(obj => {
                    outputArray.push(obj.class_num);
                });
                return outputArray.join(', ')
            }
        },
        data() {
            return {
                report: {},
                loading: true,
            }
        },
        mounted() {
            this.$store.dispatch('getMatch', this.id).then(response => {
                this.report = response;
                this.loading = false;
            });
        }
    }
</script>

<style scoped>
    .qf-report-border {
        border: 1px solid transparent;
    }

    .qf-report-border.qf-border-orange {
        border-color: #f7c000;
    }

    .devider-mid:after {
        content: '';
        top: 15%;
        left: 50%;
        height: 70%;
        width: 1px;
        background: #AEBCC2;
        position: absolute;
    }

    .flex-column.flex-sm-row > .w-25,
    .flex-column.flex-sm-row > .w-50,
    .flex-column.flex-sm-row > .w-75 {
        width: 100% !important;
    }

    @media (min-width: 576px) {
        .flex-column.flex-sm-row > .w-25 {
            width: 25% !important;
        }

        .flex-column.flex-sm-row > .w-50 {
            width: 50% !important;
        }

        .flex-column.flex-sm-row > .w-75 {
            width: 75% !important;
        }
    }


    @media (min-width: 768px) {

    }
</style>
